import { v4 as uuidv4 } from 'uuid'
import { EntityIdAndType, EntityState, EntityTypeEnum, EntityWrapper, TradingEntityMetaDetail } from 'api'
import { NEW_ITEM_PREFIX, notEmpty } from 'utils'

export const getReferenceDataEntitiesForSalesCoverAmend = (
  tradingEntityMetaDetails: TradingEntityMetaDetail[],
  primaryCover: string | null,
  secondaryCover: string | null
): [EntityWrapper[], EntityIdAndType[]] => {
  if (primaryCover !== null || secondaryCover !== null) {
    return [getUpsertReferenceDataEntities(tradingEntityMetaDetails, primaryCover, secondaryCover), []]
  } else {
    return getDeleteReferenceDataEntities(tradingEntityMetaDetails)
  }
}

const getUpsertReferenceDataEntities = (
  tradingEntityMetaDetails: TradingEntityMetaDetail[],
  primaryCover: string | null,
  secondaryCover: string | null
): EntityWrapper[] => {
  if (primaryCover === null && secondaryCover === null) {
    throw new Error('Primary and secondary cover cannot both be null')
  }

  return tradingEntityMetaDetails
    .filter(
      ({ tradingEntityMeta }) =>
        tradingEntityMeta.primaryCoverUserId !== primaryCover || tradingEntityMeta.secondaryCoverUserId !== secondaryCover
    )
    .map(({ tradingEntityMeta }) => {
      const newItem = tradingEntityMeta.id.startsWith(NEW_ITEM_PREFIX)
      const id = newItem ? uuidv4() : tradingEntityMeta.id
      return {
        data: { ...tradingEntityMeta, id, primaryCoverUserId: primaryCover, secondaryCoverUserId: secondaryCover },
        entityState: newItem ? EntityState.NEW : EntityState.EXISTING,
        entityTypeEnum: EntityTypeEnum.TRADING_ENTITY_META,
        id,
        validationIssues: null
      }
    })
}

const getDeleteReferenceDataEntities = (tradingEntityMetaDetails: TradingEntityMetaDetail[]): [EntityWrapper[], EntityIdAndType[]] => {
  return tradingEntityMetaDetails.reduce<[EntityWrapper[], EntityIdAndType[]]>(
    ([referenceDataEntities, entityIdsToDelete], { tradingEntityMeta }) => {
      if (tradingEntityMeta.id.startsWith(NEW_ITEM_PREFIX)) {
        return [referenceDataEntities, entityIdsToDelete]
      }
      if (tradingEntityMeta.aliasTypeAndValues.length || notEmpty(tradingEntityMeta.primeBrokerId)) {
        return [
          [
            ...referenceDataEntities,
            {
              data: { ...tradingEntityMeta, primaryCoverUserId: null, secondaryCoverUserId: null },
              entityState: EntityState.EXISTING,
              entityTypeEnum: EntityTypeEnum.TRADING_ENTITY_META,
              id: tradingEntityMeta.id,
              validationIssues: null
            }
          ],
          entityIdsToDelete
        ]
      } else {
        return [
          referenceDataEntities,
          [...entityIdsToDelete, { entityId: tradingEntityMeta.id, entityType: EntityTypeEnum.TRADING_ENTITY_META }]
        ]
      }
    },
    [[], []]
  )
}
